const filterByInput = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

export default filterByInput